import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

export interface AvatarUploadFormProps {
  fluidWidth?: boolean;
}

export const AvatarContainer = styled.section<AvatarUploadFormProps>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;

  @media (min-width: ${theme.breakpoint.large}px) {
    align-items: center;
  }

  ${({ fluidWidth }) =>
    fluidWidth &&
    css`
      width: 100%;
    `}

  > * {
    display: flex;
  }

  button {
    width: ${toRem(105)};
    padding: 0;
  }
`;

export const AvatarActions = styled.div`
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  margin-left: ${toRem(theme.space.xl)};

  > * {
    &:first-child {
      margin-right: ${toRem(theme.space.md)};
    }
  }
`;
